"use client";

import { useMetaPlatform } from "./provider";

export function useListDefaults(
  platform: "META" | "TIKTOK" | "GOOGLE" | "SNAPCHAT" = "META",
) {
  const { trpc, orgSlug } = useMetaPlatform();
  const query = trpc.organization.listCreativeTestingDefaults.useQuery(
    { slug: orgSlug },
    { enabled: true },
  );

  const filtered = query.data?.filter(
    (d: { platform: string }) => d.platform === platform,
  );

  return { ...query, data: filtered };
}

export function useGetDefaultById(defaultId?: string) {
  const { trpc, orgSlug } = useMetaPlatform();
  return trpc.organization.getCreativeTestingDefaultById.useQuery(
    { id: defaultId!, slug: orgSlug },
    { enabled: !!defaultId },
  );
}

export function useCreateDefault() {
  const { trpc } = useMetaPlatform();
  return trpc.organization.createCreativeTestingDefault.useMutation();
}

/**
 * Creates a new defaults record pre-filled from an existing campaign (and
 * optionally one ad set / ad group / ad squad) on any platform; the input is
 * discriminated by `platform`. The result carries origin markers
 * (`<platform>Source*`, `<platform>*Frozen`) so new-batch can auto-enter
 * reuse mode the next time the user loads this default.
 *
 * Hosted on the Meta SDK module because every provider shares the same `trpc`
 * client.
 */
export function useCreateDefaultFromTarget() {
  const { trpc } = useMetaPlatform();
  return trpc.organization.createCreativeTestingDefaultFromTarget.useMutation();
}

export function useUpdateDefault() {
  const { trpc } = useMetaPlatform();
  return trpc.organization.updateCreativeTestingDefaultById.useMutation();
}

export function useDeleteDefault() {
  const { trpc } = useMetaPlatform();
  return trpc.organization.deleteCreativeTestingDefault.useMutation();
}

export function useSetActiveDefault() {
  const { trpc } = useMetaPlatform();
  return trpc.organization.setActiveCreativeTestingDefault.useMutation();
}
